const IconEdit = ({
    width=14,
    height=14,
}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 11 11" fill="currentColor">
            <path d="M8.84583 4.20521L6.89792 2.28021L7.53958 1.63854C7.71528 1.46285 7.93108 1.375 8.18698 1.375C8.44288 1.375 8.65868 1.46285 8.83437 1.63854L9.47604 2.28021C9.65174 2.4559 9.7434 2.66788 9.75104 2.91615C9.75868 3.16441 9.67465 3.37639 9.49896 3.55208L8.84583 4.20521ZM8.18125 4.88125L3.32292 9.73958H1.375V7.79167L6.23333 2.93333L8.18125 4.88125Z" fill="currentColor"></path>
        </svg>
    )
}

export default IconEdit;